import { useState } from "react"
import { Status } from "./useStatus.types"

export function useStatus(initialValue: Status = "PENDING") {
  const [status, setStatus] = useState<Status>(initialValue)
  return { status, setStatus }
}
